var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMoonPay = function SvgMoonPay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#7D00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8474 9.30521C17.2732 9.30521 17.6893 9.17896 18.0433 8.94243C18.3973 8.7059 18.6732 8.36971 18.8362 7.97637C18.9991 7.58304 19.0417 7.15022 18.9587 6.73265C18.8756 6.31509 18.6706 5.93153 18.3695 5.63048C18.0685 5.32944 17.6849 5.12442 17.2674 5.04136C16.8498 4.9583 16.417 5.00093 16.0236 5.16386C15.6303 5.32678 15.2941 5.60269 15.0576 5.95668C14.8211 6.31068 14.6948 6.72686 14.6948 7.15261C14.6948 7.4353 14.7505 7.71522 14.8586 7.97639C14.9668 8.23757 15.1254 8.47488 15.3253 8.67477C15.5251 8.87466 15.7625 9.03322 16.0236 9.14139C16.2848 9.24956 16.5647 9.30523 16.8474 9.30521ZM10.247 19C9.20923 19 8.19478 18.6923 7.33192 18.1157C6.46905 17.5392 5.79654 16.7197 5.3994 15.761C5.00227 14.8022 4.89837 13.7472 5.10082 12.7294C5.30328 11.7116 5.80301 10.7766 6.53681 10.0428C7.27062 9.30904 8.20554 8.80931 9.22336 8.60686C10.2412 8.4044 11.2962 8.50831 12.2549 8.90545C13.2137 9.30258 14.0331 9.9751 14.6097 10.838C15.1862 11.7008 15.494 12.7153 15.494 13.753C15.494 14.4421 15.3583 15.1244 15.0946 15.761C14.8309 16.3976 14.4444 16.976 13.9572 17.4632C13.47 17.9505 12.8915 18.337 12.2549 18.6006C11.6183 18.8643 10.936 19 10.247 19Z",
    fill: "white"
  })));
};

export { SvgMoonPay as ReactComponent };
export default __webpack_public_path__ + "6a9b37528e14989d961f69793a9d2105.svg";